import "./FramePdf.styles.scss";

interface iFramePdfProps {
    file: string;
    title: string;
    initialPage?: number;
}
const FramePdf: React.FC<iFramePdfProps> = ({
    file,
    title,
    initialPage,
}) => {
    const pdfSrc = initialPage ? `${file}#page=${initialPage}` : file;

    return <iframe
        className="FramePdf"
        title={title}
        src={pdfSrc}
        itemType={"application/pdf"}
    />
}

export default FramePdf;